import React, { useContext, useEffect } from "react";
import { LangContext } from "../../../context/lang/LangContext";
import { useCustomers } from "./hooks/useCustomers";
import { DeveloperCard } from "./components/DeveloperCard";
import { ArrowLeft } from "./components/ArrowLeft";
import { ArrowRight } from "./components/ArrowRight";

const Customers = () => {
  const { messages } = useContext(LangContext);
  const {
    developers,
    getDevelopers,
    handleNext,
    handlePrev,
    developersContainerRef,
  } = useCustomers();

  useEffect(() => {
    getDevelopers();
  }, []);

  return (
    <div className="Customers_Section__container">
      <h1 className="Customers_Section__container_title">
        {messages.sections.customers.our}{" "}
        <span>{messages.sections.customers.successStories}</span>
      </h1>
      <div
        ref={developersContainerRef}
        className="Customers_Section__developers_container"
      >
        {developers?.map((developer, i) => (
          <DeveloperCard
            id={String(i)}
            key={developer.id}
            developer={developer}
          />
        ))}
      </div>
      <div className="Customers_Section__footer">
        <button onClick={handlePrev}>
          <ArrowLeft />
        </button>
        <button onClick={handleNext}>
          <ArrowRight />
        </button>
      </div>
    </div>
  );
};

export default Customers;
